<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="standard-modalLabel">
          {{ 'contact.customerPortfolioTransfer.selectUser' | translate }}
        </h4>

        <button
          [matDialogClose]=""
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
        ></button>
      </div>

      <div class="modal-body mt-4">
        <form [formGroup]="formGroup">
          <div class="col-lg-12 mb-3">
            <label class="form-label">{{ 'contact.customerPortfolioTransfer.department' | translate }}</label>
            <mat-select
              class="form-control"
              formControlName="department"
              [placeholder]="'contact.customerPortfolioTransfer.selectDepartment' | translate"
              #department
              (selectionChange)="changeDepartment()"
            >
              <div class="m-1">
                <input
                  class="form-control"
                  type="text"
                  [formControl]="filterControlDeparment"
                  [placeholder]="'contact.customerPortfolioTransfer.searchDepartment' | translate"
                />
              </div>
              <mat-option [value]="null">{{ 'contact.customerPortfolioTransfer.selectOption' | translate }}</mat-option>
              @for (item of allDepartments; track item) {
              <mat-option [value]="item._id">{{ item.name }}</mat-option>
              }
            </mat-select>
            <field-error-component
              [field]="'department'"
              [label]="'contact.portfolioTransfer.departmentLabel' | translate"
              [formGroup]="formGroup"
            />
          </div>
          <div class="col-lg-12 mb-3">
            <label class="form-label">{{ 'contact.customerPortfolioTransfer.attendant' | translate }}</label>
            <mat-select
              class="form-control"
              formControlName="attendant"
              [placeholder]="'contact.customerPortfolioTransfer.selectAttendant' | translate"
              #department
            >
              <div class="m-1">
                <input
                  class="form-control"
                  type="text"
                  [formControl]="filterControlAttendant"
                  [placeholder]="'contact.customerPortfolioTransfer.searchAttendant' | translate"
                />
              </div>
              <mat-option [value]="null">{{ 'contact.customerPortfolioTransfer.selectOption' | translate }}</mat-option>
              @for (item of allAttendant; track item) {
              <mat-option [value]="item._id">{{ item.name }}</mat-option>
              }
            </mat-select>
            <field-error-component
              [field]="'attendant'"
              [label]="'contact.portfolioTransfer.attendantLabel' | translate"
              [formGroup]="formGroup"
            />
          </div>
          <div class="row">
            <div class="col-12 gap-2 d-flex justify-content-end pb-4">
              <button
                [matDialogClose]=""
                class="mt-3 btn btn-secondary fw-bold"
              >
                {{ 'contact.customerPortfolioTransfer.close' | translate }}
              </button>
              <button
                class="mt-3 btn btn-primary fw-bold"
                [disabled]="!formGroup.valid || loading"
              >
                {{ 'contact.customerPortfolioTransfer.save' | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
